import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';

import { Container, Row, Col } from 'reactstrap';
import Swiper from 'react-id-swiper';
import moment from 'moment';
import _ from 'lodash';

import * as vars from '../../constants/constants';
import { show, hide } from '../../actions/ActivityIndicatorActions';
import { getVideoOrChannelRelatedData } from '../../actions/PlayActions';
import { setHeaderTitle } from '../../actions/HeaderActions';
import { clearHistory } from '../../actions/HistoryActions';
import { console_log, fromNow } from '../../utils/helper';

import { Images360 } from '../../constants/images360';
import { FormattedMessage } from 'react-intl';
import {config} from './../../constants/domainConfig';
import { sendData } from '../../analytics/sendData';
class Panoramic extends Component {
    constructor(props) {
        super(props);
        this.state = {
            type: '',
            allVids: []
        };
        this.swiper = null;
        this.interval = null;
    }

    componentWillMount() {
        this.setState({
            allVids: Images360
        })
            
        //if (this.props.access.token != '') {
            // axios.defaults.headers.common['authorization'] = this.props.access.token;
        //}

    }

    componentDidMount() {
    sendData('', '', 'VR Image', 'viewed');
        this.interval = setInterval(() => {
            if (this.swiper != null) {
                this.swiper.slideNext();
            }
        }, 40000);
        const headerText = {
            en: "Panoramic 360",
            pt: "Panorâmico 360",
            ar: "بانورامي 360",
            cy: "Панорама 360",
            ee: "360 Panoraam",
            es: "Vista panorámica",
            it: "Panoramica 360",
            el: "Πανοραμικό 360",
            id: "Panorama 360",
            si:"Panoramski 360",
            pl: "Panoramiczny 360"
        }
        this.props.setHeaderTitle(headerText[config.lang]);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    shuffle(videoArray) {
        let ctr = videoArray.length;
        let temp;
        let index;
    
        // While there are elements in the array
        while (ctr > 0) {
            index = Math.floor(Math.random() * ctr);
            ctr--;
            temp = videoArray[ctr];
            videoArray[ctr] = videoArray[index];
            videoArray[index] = temp;
        }
        return videoArray;
    }

    goToPlayImage(data, event) {
        event.preventDefault();
        this.props.getVideoOrChannelRelatedData(data);
        this.props.history.push(`/panoramic-show/${data.categoryId}/${data.imageData.id}`);
    }

    render() {
        
        const Imovies1 = Images360;
            
        const params = {
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            lazy: {
                loadPrevNext: true,
            },
            loop: true,
        },
        portraitSlides = {
            direction: 'horizontal',
            slidesPerView: 'auto',
            spaceBetween: 10,
            speed: 500,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        },
        slides = {
            direction: 'horizontal',
            slidesPerView: 'auto',
            spaceBetween: 10,
            speed: 500,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                575: {
                    spaceBetween: 15,
                },
            }
        },
        hollowArrow = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="36.2px" height="34.4px" viewBox="0 0 52.1 67.8" style="enable-background:new 0 0 52.1 67.8;" xml:space="preserve"><path d="M0 67.8V0l52.1 33.9L0 67.8zM4 7.4v52.9l40.6-26.4L4 7.4z"></path></svg>',
        gridIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 290 290" width="16" height="16"><g fill="#8165a8"><path d="M0 220h70v70H0zM0 110h70v70H0zM0 0h70v70H0zM110 220h70v70h-70zM110 110h70v70h-70zM110 0h70v70h-70zM220 220h70v70h-70zM220 110h70v70h-70zM220 0h70v70h-70z"/></g></svg>';
        let isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g);
        
      
        return(<section className="category banner-slider">
             <div className="banner-slider__wrap">
                 <div className="custom-slider-container fullView">
                                <div className="responsive-banner">
                                    <img className="responsive-banner-image" src="./img//mobio-360-homebanner.jpg" alt="" />
                                </div>
                                <h3  className="banner-text-right">
                                <FormattedMessage id="homeCatBannerText"
                                    defaultMessage="EXPERIENCE THE EXTRAORDINARY "
                                />
                                </h3>
                                
                </div>
              </div>
              
              <div className="star-banner"></div>
              <div className="category-head" id="on-top-star"></div>  
                {
                     Imovies1.map((category) => {
                            return (
                                <div key={category.id} className="portrait-wrapper">
                                    <div className="d-flex justify-content-between channel-head">
                                        <h3 className="channel-title image360-cat-title">{category.categoryName[config.lang] || category.categoryName.en}</h3>
                                        {/* <a className="channel-browse" href={"/#/movies/"+category.id}>
                                            <span className="grid-icon" dangerouslySetInnerHTML={{ __html: gridIcon }} />
                                            View All
                                        </a> */}
                                    </div>
                                    {category.images.length > 0 ?
                                        <Swiper {...portraitSlides} rebuildOnUpdate={false} shouldSwiperUpdate={true}>
                                            {this.shuffle(category.images).map((m) => {
                                                return (
                                                    <div key={m.id} className="image360-portrait__slide hover__data" onClick={this.goToPlayImage.bind(this, {imageData: m,categoryId:category.id})}>
                                                        <img src={m.ImageUrl} alt={m.name} />
                                                        
                                                        <div className="hover__details">
                                                            <div className="hover__container">
                                                                {/* <h3 className="image360-hover__title">{m.name}</h3> */}
                                                                <span className="hollow-arrow" dangerouslySetInnerHTML={{ __html: hollowArrow }} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                                })
                                            }
                                        </Swiper>
                                        : ''
                                    }
                                </div>
                            )
                        })
                }


            </section>)
	}
}

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        show,
        hide,
        setHeaderTitle,
		clearHistory,
        getVideoOrChannelRelatedData
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Panoramic);


// WEBPACK FOOTER //
// ./src/components/Panoramic/Panoramic.js